<template>
  <div class="mb-4" v-if="show">
    <div class="">
      <div class="">
        <h6 class="fw-bold">
          {{ 'Payment information' | translate }}
        </h6>
      </div>
      <div class="">
        <InputErrors name="cypher"></InputErrors>
        <InputErrors name="transaction"></InputErrors>
        <div class="mb-2">
          <div class="d-flex justify-content-between">
            <label for="card-number" class="">
              <small>{{ 'Card Number' | translate }}</small>
            </label>
            <span v-if="valid.card.niceType">
              <img v-if="cardLogoSrc" class="img-fluid" :src="cardLogoSrc" :alt="valid.card.niceType" />
              <span v-else>{{ valid.card.niceType }}</span>
            </span>
            <span v-else>
              <img
                class="img-fluid"
                src="https://djceg34j53tq.cloudfront.net/integrations/logos/mastercard.svg"
                alt="Mastercard"
              />
              <img
                class="img-fluid"
                src="https://djceg34j53tq.cloudfront.net/integrations/logos/visa2.svg"
                alt="Visa"
              />
              <img
                class="img-fluid"
                src="https://djceg34j53tq.cloudfront.net/integrations/logos/discover.svg"
                alt="Discover"
              />
              <img
                class="img-fluid"
                src="https://djceg34j53tq.cloudfront.net/integrations/logos/americanexpress.svg"
                alt="AmericanExpress"
              />
            </span>
          </div>
          <input
            v-mask="mask"
            type="tel"
            id="card-number"
            class="form-control"
            :class="{
              'is-valid': validatedCardNumber,
              'is-invalid': invalidCardNumber,
            }"
            v-model="fields.cardNumber"
            @change="cypher"
          />
        </div>
        <div class="mb-2">
          <div class="row">
            <div class="col-8">
              <label for="">
                <small>{{ 'Expiration Date' | translate }}</small>
              </label>
              <div class="row">
                <div class="col">
                  <select
                    class="form-control"
                    :class="{
                      'is-valid': validatedCardExpirationDate,
                      'is-invalid': invalidCardExpirationDate,
                    }"
                    v-model="fields.cardMonth"
                    @change="cypher"
                  >
                    <option value="" disabled selected>
                      {{ 'Month' | translate }}
                    </option>
                    <option v-for="i in 12" :key="i" v-bind:value="i < 10 ? '0' + i : i">
                      {{ i }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <select
                    class="form-control"
                    :class="{
                      'is-valid': validatedCardExpirationDate,
                      'is-invalid': invalidCardExpirationDate,
                    }"
                    v-model="fields.cardYear"
                    @change="cypher"
                  >
                    <option value="" disabled selected>
                      {{ 'Year' | translate }}
                    </option>
                    <option v-for="(i, $index) in 12" v-bind:value="$index + minCardYear" :key="$index">
                      {{ $index + minCardYear }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col">
              <label for="card-cvv">
                <small>{{ valid.card.code.name }}</small>
              </label>
              <input
                v-mask="cvvMask"
                id="card-cvv"
                type="tel"
                class="form-control"
                :class="{
                  'is-valid': validatedCardCVV,
                }"
                v-model="fields.cardCvv"
                @change="cypher"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import valid from 'card-validator'
import _ from 'lodash'
import JSEncrypt from 'jsencrypt'
import InputErrors from './../InputErrors'

export default {
  components: {
    InputErrors,
  },
  directives: { mask },
  props: ['showComponent', 'publicRsaProp'],
  data() {
    return {
      fields: {
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
      },
      minCardYear: new Date().getFullYear(),
    }
  },
  computed: {
    cardLogoSrc() {
      let base = 'https://djceg34j53tq.cloudfront.net/integrations/logos/'
      let logo = null

      if (_.get(this.valid, 'card.niceType') === 'Mastercard') {
        logo = 'mastercard.svg'
      }
      if (_.get(this.valid, 'card.niceType') === 'Visa') {
        logo = 'visa2.svg'
      }
      if (_.get(this.valid, 'card.niceType') === 'Discover') {
        logo = 'discover.svg'
      }
      if (_.get(this.valid, 'card.niceType') === 'American Express') {
        logo = 'americanexpress.svg'
      }
      if (logo) {
        return `${base}${logo}`
      }

      return null
    },
    selectedPlanPriceIsZero() {
      if (_.get(this.$store.getters.currentPlan, 'price') === 0) {
        return true
      }

      return false
    },
    show() {
      if (this.showComponent) {
        return true
      }
      if (this.selectedPlanPriceIsZero) {
        return false
      }

      let view = this.$store.state.view
      if (this.student.email || view === 'register') {
        return true
      }

      return false
    },
    student() {
      return this.$store.state.user
    },
    publicRSA() {
      if (this.publicRsaProp) {
        return this.publicRsaProp
      }
      return this.$store.state.publicRSA
    },
    number() {
      return this.fields.cardNumber.replace(/\s/g, '')
    },
    mask() {
      let type = this.valid.card
      let length = _.last(type.lengths)
      return _.range(length)
        .map((i) => {
          if (_.includes(type.gaps, i)) return ' #'
          return '#'
        })
        .join('')
    },
    cvvMask() {
      return _.range(this.valid.card.code.size)
        .map((i) => '#')
        .join('')
    },
    valid() {
      let v = valid.number(this.number)
      if (v.card) return v

      return {
        card: {
          type: '',
          niceType: '',
          lengths: [16],
          gaps: [4, 8, 12],
          code: { name: 'CVV', size: 3 },
        },
        isPotentiallyValid: true,
        isValid: false,
      }
    },
    validatedCardNumber() {
      if (this.valid.isValid) return true
      return false
    },
    invalidCardNumber() {
      if (this.valid.isPotentiallyValid) return false
      return true
    },
    validatedCardExpirationDate() {
      const v = valid.expirationDate(this.fields.cardMonth + '/' + this.fields.cardYear)
      if (v.isValid) return true
      return false
    },
    invalidCardExpirationDate() {
      const v = valid.expirationDate(this.fields.cardMonth + '/' + this.fields.cardYear)
      if (v.isPotentiallyValid) return false
      return true
    },
    validatedCardCVV() {
      const v = valid.cvv(this.fields.cardCvv)
      if (v.isValid) return true
      return false
    },
  },
  methods: {
    tooltipStart(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    tooltipStop(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },

    cypher() {
      if (
        ![this.validatedCardNumber, this.validatedCardExpirationDate, this.validatedCardCVV].every((element) => element)
      ) {
        return false
      }

      const cd =
        this.number +
        '|' +
        this.fields.cardMonth +
        '/' +
        this.fields.cardYear +
        '|' +
        this.fields.cardCvv +
        '|' +
        document.location.origin

      const decoded = Buffer.from(this.publicRSA, 'base64').toString('ascii')
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(decoded)
      const cypher = encrypt.encrypt(cd)
      this.$store.commit('setCypher', cypher)
      return cypher
    },
  },
}
</script>
